export default __webpack_public_path__ + "static/media/56.91da0d12.jpg";